/* import __COLOCATED_TEMPLATE__ from './page-click.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
let PageClickComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipass-tracking'), _class = class PageClickComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    _initializerDefineProperty(this, "tracking", _descriptor2, this);
    _defineProperty(this, "initPageClick", el => {
      if (el.childElementCount !== 1) {
        throw new Error('Page click tracker only supports single child element');
      }
      el.children[0].addEventListener('click', this.click);
    });
    _defineProperty(this, "click", event => {
      try {
        const elementData = {
          elementIdentifier: this.args.trackId ?? event.target.id,
          elementText: this.args.trackText ?? event.target.textContent.trim().replace(/\s+/g, ' ').slice(0, 300),
          elementTitle: this.args.trackTitle ?? event.target.title,
          elementType: event.target.tagName.toLowerCase()
        };
        if (this.args.type === 'link') {
          this.tracking.trackLinkClick(elementData);
        } else if (this.args.type === 'button') {
          this.tracking.trackButtonClick(elementData);
        }
      } catch (e) {
        // tracking errors should not bubble and interfere w/ application flow
        this.logger.sentryError(e);
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tracking", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PageClickComponent as default };